package com.essntl.features.itinerary.ui.edit_itinerary.utils

import androidx.compose.ui.graphics.Color
import core.dateformat.utils.parseLocalDateOrNull
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryState
import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.ui.getNumberOfDays
import com.essntl.features.proposal.ui.getPdfService
import core.pdf.itinerary.PdfState
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.plus

fun getItineraryMessages(
    categoryList: List<CategoryModel>,
    itineraryServiceList: List<ItineraryServiceModel>,
    client: ClientModel?,
    profile: ProfileModel,
    isEmailChecked: Boolean,
    isWhatsappChecked: Boolean,
    isMessageChecked: Boolean,
    typedMessage: String,
    ccEmail: String?,
    toEmail: String,
    from: String?,
    bcc: String?,
    replyTo: String?,
    multiTemplateId: String?,
    simpleTemplateId: String?,
    showsServiceInfo: Boolean,
    toTelephoneNumber: String,
    telephone: String?,
): List<MessageModel> {
    val messageList = mutableListOf<MessageModel>()

    if (isEmailChecked && toEmail.isNotBlank()) {
        val message =
            if (showsServiceInfo)
                MessageModel.empty.copy(
                    userText = typedMessage,
                    serviceList = itineraryServiceList.map { it.service },
                    categoryList = categoryList,
                    itineraryServiceList = itineraryServiceList,
                    client = client ?: ClientModel.empty,
                    sender = profile,
                )
            else
                MessageModel.empty.copy(
                    userText = typedMessage,
                    sender = profile,
                )

        messageList.add(
            message.copy(
                itineraryServiceList = itineraryServiceList,
                type = MessageModel.Type.Email(
                    email = toEmail,
                    cc = ccEmail,
                    from = from,
                    bcc = bcc,
                    replyTo = replyTo,
                    multiTemplateId = multiTemplateId,
                    simpleTemplateId = simpleTemplateId,
                ),
            ),
        )
    }

    itineraryServiceList.forEach { itineraryService ->
        val category =
            categoryList.firstOrNull {
                it.id == itineraryService.service.category
            } ?: return@forEach

        val message =
            if (showsServiceInfo)
                MessageModel.empty.copy(
                    userText = typedMessage,
                    serviceList = listOf(itineraryService.service),
                    categoryList = listOf(category),
                    itineraryServiceList = listOf(itineraryService),
                    client = client ?: ClientModel.empty,
                    sender = profile,
                )
            else
                MessageModel.empty.copy(
                    itineraryServiceList = itineraryServiceList,
                    serviceList = itineraryServiceList.map { it.service },
                    categoryList = categoryList,
                    userText = typedMessage,
                )

        if (isMessageChecked && telephone != null)
            messageList.add(message.copy(type = MessageModel.Type.Sms(telephone)))

        if (isWhatsappChecked && toTelephoneNumber.isNotEmpty()) {
            messageList.add(message.copy(type = MessageModel.Type.Whatsapp(toTelephoneNumber)))
        }
    }

    return messageList
}

fun getPdfState(
    state: EditItineraryState,
    proposal: ProposalModel?,
    primaryClient: ClientModel?,
    coverImage: FileModel?,
    beLogo: ByteArray,
    manropeFont: ByteArray,
    manropeBoldFont: ByteArray,
    brandColor: Color,
): PdfState {
    val numberOfDays = proposal.getNumberOfDays()

    return com.essntl.features.proposal.ui.getPdfState(
        numberOfDays = numberOfDays,
        getServices = { index ->
            val localDate = parseLocalDateOrNull(proposal?.fromDate)?.plus(DatePeriod(days = index))

            val dayItineraryServiceList =
                state.getAllItineraryService.data
                    .orEmpty()
                    .filter {
                        it.startDate == localDate.toString() && it.status != ItineraryServiceModel.Status.Cancelled
                    }

            dayItineraryServiceList.mapIndexed { serviceIndex, itineraryService ->
                getPdfService(
                    serviceIndex = serviceIndex,
                    categoryList = state.getAllCategory.data.orEmpty(),
                    service = itineraryService.service,
                    htmlDescription = itineraryService.editedDescription,
                    startTime = itineraryService.startTime,
                    endTime = itineraryService.endTime,
                    address = itineraryService.address?.description,
                    contactName = itineraryService.supplierContact?.prettyName,
                    contactPhone = itineraryService.supplierContact?.phoneNumber,
                    price = null,
                )
            }
        },
        proposal = proposal,
        primaryClient = primaryClient,
        coverImage = coverImage,
        beLogo = beLogo,
        manropeFont = manropeFont,
        manropeBoldFont = manropeBoldFont,
        brandColor = brandColor,
    )
}